import "./Home.css";
import Hero from "../../components/Hero/Hero";
import { Link } from "react-router-dom";
import SmallHeading from "../../components/SmallHeading/SmallHeading";
import Heading from "../../components/Heading/Heading";
import ArrowLink from "../../components/ArrowLink/ArrowLink";
import ScrollAnimation from "../../components/ScrollAnimation/ScrollAnimation";
import H1 from "../../components/H1/H1";

const Home = () => {
    const pillars = [
        {
            title: "Advisory",
            items: ["Investment advisory", "Deal advisory", "Philanthropy advisory"],
            link: "/advisory",
            image: "/images/waves/home1.jpg",
        },
        {
            title: "Investments",
            items: ["Principal investments", "Co-investments", "Australian emerging fund managers"],
            link: "/investments",
            image: "/images/waves/home2.jpg",
        },
        {
            title: "Operations",
            items: ["Executive services", "Australian fund manager services"],
            link: "/operations",
            image: "/images/waves/home3.jpg",
        },
    ];

    return (
        <div className="page-content home-page">
            <Hero name="home">
                <H1>Creative. Capital.</H1>

                <ScrollAnimation className="hero-details" delay={200}>
                    River is an independent, owner-led investment and advisory group. We invest
                    across global alternatives, pursue uncorrelated returns, and fuse capital with
                    operations to generate lasting impact.
                </ScrollAnimation>

                <ArrowLink text="Explore portfolio" link="/portfolio" delay={400} />

                <ScrollAnimation className="hero-icon" type="revealLeft" delay={600}>
                    <svg
                        preserveAspectRatio="xMidYMid meet"
                        data-bbox="0.93 0 76.3 76.3"
                        viewBox="0.93 0 76.3 76.3"
                        xmlns="http://www.w3.org/2000/svg"
                        data-type="color"
                        role="presentation"
                        aria-hidden="true"
                        aria-label=""
                    >
                        <g>
                            <path
                                d="M.93 0v27.2h1.1c2.4 0 3.4-.5 4.9-1.1 1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8v7.2c-2.4 0-3.4.5-4.9 1.1-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8H.93v8.3h1.1c2.4 0 3.4-.5 4.9-1.1 1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8V47c-2.4 0-3.4.5-4.9 1.1-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8H.93v8.3h1.1c2.4 0 3.4-.5 4.9-1.1 1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8s6.1 1 7.9 1.8c1.4.7 2.5 1.1 4.9 1.1s3.4-.5 4.9-1.1c1.7-.8 3.9-1.8 7.9-1.8v7.2c-2.4 0-3.4.5-4.9 1.1-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8s-6.1-1-7.9-1.8c-1.4-.7-2.5-1.1-4.9-1.1s-3.4.5-4.9 1.1c-1.7.8-3.9 1.8-7.9 1.8H.93v10.9h76.3V0z"
                                fill="white"
                                data-color="1"
                            ></path>
                        </g>
                    </svg>
                </ScrollAnimation>
            </Hero>

            <section className="padded">
                <div className="container">
                    <SmallHeading text="WHAT WE DO" />

                    <Heading>We operate across three pillars.</Heading>

                    <div className="flex pillars-container">
                        {pillars.map((pillar, index) => (
                            <ScrollAnimation
                                key={index}
                                className="pillar"
                                type="revealUp"
                                delay={index * 100}
                            >
                                <Link to={pillar.link}>
                                    <img
                                        src={pillar.image}
                                        alt={pillar.title}
                                        className="pillar-image"
                                    />
                                </Link>

                                <Link to={pillar.link} className="pillar-heading">
                                    {pillar.title}
                                </Link>

                                <ul className="pillar-items">
                                    {pillar.items.map((item, itemIndex) => (
                                        <li key={itemIndex}>
                                            <span className="bullet"></span> {item}
                                        </li>
                                    ))}
                                </ul>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </section>

            <section className="our-principles bg-fixed">
                <div className="our-principles-inner">
                    <div className="container">
                        <SmallHeading text="WHAT WE STAND FOR" fillColour="white" />

                        <Heading>Our principles.</Heading>

                        <ScrollAnimation className="our-principles-text" delay={300}>
                            <p>
                                At River, our engagement with families, partners and clients is
                                guided by our core values and enduring principles.
                            </p>

                            <p>
                                We think long-term, build with aligned partners, and unite capital
                                with hands-on support. We draw on deep domain expertise and prize
                                cash yield and multiples over IRR.
                            </p>
                        </ScrollAnimation>

                        <ArrowLink text="Meet the team" link="/about-river" />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
